// extracted by mini-css-extract-plugin
export default {"authBackground":"App_authBackground__+bffy","dashboard":"App_dashboard__cH-34","toast":"App_toast__Mt+5G","fadeInUp":"App_fadeInUp__l1Mwi"};